// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__J_SVq","description":"styles_description__2Y4rz"};